var host = 'http://139.196.176.75:9100';

var axiosurl = {
    host,
    user: {
        list: `${host}/user/list`, //分页列表  use
        del: `${host}/user/del`, //删除用户  use
        accessstatus: `${host}/user/accessstatus`, //验证用户扫码通过情况  use
        qrcode: `${host}/user/qrcode`, //用户二维码  use
        register: `${host}/user/register`, //用户注册  use
        login: `${host}/user/login`, //登录  use
        captchalogin: `${host}/user/captchalogin` //短信登录  use
    },
    workshop: {
        del: `${host}/workshop/del`, //删除车间  use
        edit: `${host}/workshop/edit`, //更新车间  use
        layout: `${host}/workshop/layout`, //更新车间布局  use
        add: `${host}/workshop/add`, //添加车间  use
        layoutinfo: `${host}/workshop/layoutinfo`, //获取指定车间布局  use
        layouts: `${host}/workshop/layouts`, //获取车间布局
        select: `${host}/workshop/select`, //车间下拉列表  use
        list: `${host}/workshop/list` //车间列表  use
    },
    group: {
        status: `${host}/group/status`, //当前机组状态  use
        devices: `${host}/group/devices`, //机组中包含的设备  use
        list: `${host}/group/list`, //机组列表  use
        edit: `${host}/group/edit`, //编辑机组  use
        listbyws: `${host}/group/listbyws`, //首页机组统计  use
        singlecount: `${host}/group/singlecount`, //单个机组统计  use
        releasedevicebatch: `${host}/group/releasedevicebatch`, //批量移除设备  use
        adddevicebatch: `${host}/group/adddevicebatch`, //批量添加设备  use
        add: `${host}/group/add`, //添加机组  use
        del: `${host}/group/del`, //删除机组  use
        select: `${host}/group/select` //机组下拉菜单  use
    },
    device: {
        add: `${host}/device/add`, //添加设备  use
        edit: `${host}/device/edit`, //编辑设备  use
        list: `${host}/device/list`, //设备列表  use
        currentdata: `${host}/device/currentdata`, //设备实时数据  use
        currentstatus: `${host}/device/currentstatus`, //设备实时状态  use
        select: `${host}/device/select`, //设备下拉列表  use
        historydata: `${host}/device/historydata`, //设备历史数据  use
        del: `${host}/device/del` //删除用户名下设备  use
    },
    alarm: {
        list: `${host}/alarm/list`, //报警列表  use
        current: `${host}/alarm/current` //最近报警信息  use
    },
    analysis: {
        grouppower: `${host}/analysis/grouppower`, //各设备用电量分析
        groupoee: `${host}/analysis/groupoee`, //各设备使用率分析
        groupyield: `${host}/analysis/groupyield` //各设备产量分析
    },
    plan: {
        list: `${host}/plan/list`, //生产计划列表  use
        add: `${host}/plan/add`, //添加生产计划  use
        edit: `${host}/plan/edit`, //编辑生产计划  use
        del: `${host}/plan/del`, //删除生产计划  use
        changestatus: `${host}/plan/changestatus` //更新生产计划状态  use
    },
    sms: {
        captcha: `${host}/sms/captcha` //发送验证码  use
    },
    worktime: {
        del: `${host}/worktime/del`, //删除工作时间  use
        list: `${host}/worktime/list`, //工作时间列表  use
        edit: `${host}/worktime/edit`, //更新工作时间  use
        add: `${host}/worktime/add` //添加工作时间  use
    }
};

export default axiosurl;



// WEBPACK FOOTER //
// ./src/axiosurl.js